import React from "react";
import StakeSGTComponent from "pages/stake-sgt/components/StakeSGTComponent";

const StakeSgt = () => {
  return (
    <div>
      <StakeSGTComponent type="re-stake" />
    </div>
  );
};
export default StakeSgt;
